import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faPrint } from '@fortawesome/free-solid-svg-icons/faPrint';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import {faCheckSquare} from "@fortawesome/free-solid-svg-icons/faCheckSquare";

export const svgIcons = {
	faDownload,
	faSearch,
	faPowerOff,
	faUser,
	faFile,
	faCog,
	faSync,
	faPrint,
	faFilter,
	faAngleDown,
	faUsers,
	faPlus,
	faTrashAlt,
	faEdit,
	faUndo,
	faExclamationTriangle,
	faArrowLeft,
	faTimesCircle,
	faTimes,
	faCheckSquare
};
